import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import AssetBasic from "site-apps/assets/components/AssetBasic";

const TabContainers = ({onClickSelectAssets, assets}) => {


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 text-end mb-3">
                    <button type="button" className="btn btn-outline-primary" onClick={onClickSelectAssets}>
                        <FontAwesomeIcon icon="pen"/>
                    </button>
                </div>
                <div className="col-12">
                    <ul className="list-unstyled">
                        {
                            assets.map((_asset, index) =>
                                <li className="border rounded p-2 mb-3 bg-white" key={index}>
                                    <AssetBasic asset={_asset} key={_asset.id}/>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default TabContainers;